import { render, staticRenderFns } from "./SelectionQuestion.vue?vue&type=template&id=ba009a5c&scoped=true&"
import script from "./SelectionQuestion.vue?vue&type=script&lang=js&"
export * from "./SelectionQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SelectionQuestion.vue?vue&type=style&index=0&id=ba009a5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba009a5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VSelect})
